import { OrganizationKeyName } from "../../../model/Organization";
import { GetOrderListFilters } from "../model/GetOrderListFilters";
import { OrderListItem } from "../model/OrderListSuccessResponse";

export const GET_ORDER_LIST_SUCCESS = "SHOP:GET_ORDER_LIST_SUCCESS";

export const getOrderListSuccessAction = (
  organization: OrganizationKeyName,
  filters: GetOrderListFilters,
  data: OrderListItem[]
) => ({
  type: GET_ORDER_LIST_SUCCESS as typeof GET_ORDER_LIST_SUCCESS,
  organization,
  filters,
  data,
});

export type GetOrderListSuccessAction = ReturnType<
  typeof getOrderListSuccessAction
>;
